export async function getPosts(params) {
  const get_posts = await fetch(cg_vars.gridContent_api_url + "?" + params);
  let myPosts = await get_posts.json();
  return myPosts;
}
